import { apiRequest, type Schemas } from "./client";

export type CatalogueListing = Schemas["CatalogueListing"];
export type ListingDetail = Schemas["CatalogueListingDetail"];
export type Plate = Schemas["CatalogueAssembly"];
export type PlatePosition = Plate["positions"][number];
export type PlateListing = PlatePosition["listings"][number];
export type MachineFamily = Schemas["CatalogueEquipmentCategoryList"]["data"][number];
export type Machine = Schemas["CatalogueEquipmentModel"];
export type ProductType = Schemas["CatalogueProductType"];
export type ListingPage = Schemas["CatalogueCardPage"];
export type ListingCard = Schemas["CatalogueCard"];
export type HomeShelves = Schemas["CatalogueHome"]["data"];
export type KitCard = HomeShelves["kits"][number];

const data = <T>(response: { data: T }) => response.data;

/** The public catalogue. Read-only, and priced for whoever is looking. */
export const catalogueApi = {
  machineFamilies: () => apiRequest<Schemas["CatalogueEquipmentCategoryList"]>("/api/v1/equipment_categories").then(data),
  machine: (id: number) => apiRequest<Schemas["CatalogueEquipmentModelRecord"]>(`/api/v1/equipment_models/${id}`).then(data),
  plate: (id: number) => apiRequest<Schemas["CatalogueAssemblyRecord"]>(`/api/v1/assemblies/${id}`).then(data),
  listing: (id: number) => apiRequest<Schemas["CatalogueListingDetailRecord"]>(`/api/v1/listings/${id}`).then(data),
  /** In the order asked, leaving out any no longer for sale. */
  listings: (ids: number[]) => apiRequest<Schemas["CatalogueCardList"]>("/api/v1/listings", { params: { ids: ids.join(",") } }).then(data),
  home: () => apiRequest<Schemas["CatalogueHome"]>("/api/v1/home").then(data),
  productTypes: () => apiRequest<Schemas["CatalogueProductTypeList"]>("/api/v1/product_types").then(data),
  productType: (id: number) => apiRequest<Schemas["CatalogueProductTypeRecord"]>(`/api/v1/product_types/${id}`).then(data),
  productTypeListings: (id: number, cursor?: string) =>
    apiRequest<ListingPage>(`/api/v1/product_types/${id}/listings`, { params: { cursor } }),
};

export type SearchResults = Schemas["CatalogueSearch"]["data"];
export type SearchListing = SearchResults["listings"][number];

/** PRD screen 6: a part number typed any way, or words, in one department if chosen. */
export const searchApi = {
  search: (q: string, productTypeId?: number) =>
    apiRequest<Schemas["CatalogueSearch"]>("/api/v1/search", { params: { q, product_type_id: productTypeId } }).then(data),
};
